module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm06_ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('em', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("I owe a number of people a great deal of thanks for the intellectual and emotional support and assistance they offered me in the course of writing this book. Peter Stearns, whose work on the history of emotions informs my own, was an enthusiastic supporter of the dissertation on which the book is based. It was largely due to his efforts that the dissertation came to the attention of NYU Press. Others who were instrumental in the dissertation stage of the book include Jeanne Bowlan, Sue Rovi, Jennifer Fuld, Judith Gerson, Richard Williams, Sarah Rosenfield, Patricia Roos, Roberto Franzosi, Jerry and Carroll McDaniel, Mary and Arvin Parrent, and Catherine and Ferrell Rollins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For friendship, food, fun, and intellectual stimulation during the process of transforming the dissertation into a book, I thank Melissa Green, Nina Mulia and Peter Varadi, Anne Lown, Kitty McDaniel, Francesca and Aedan Raynal, Michelle Boyle, and Tom and Tina Avila. For helpfully spotting a number of typos throughout the manuscript and for research assistance, my thanks to Brian Skinner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I offer my biggest thanks to Katharine Jones. Her steady friendship, critical eye, good humor, and patient willingness to read and comment upon numerous drafts of the manuscript sustained me throughout the writing process.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a414c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_ack.vue
// module id = 72
// module chunks = 0